import { createSelector } from '@ngrx/store';
import { getQivosMemberDetailsState } from '../reducers';

export const getMemberDetailsState = createSelector(
  getQivosMemberDetailsState,
  (state) => state.memberDetails
);
